'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'

import { findThumbnail } from '../../../utils/photo'
import { formatEscrowFeeFallback } from '../../../utils/escrow-pricing'
import ServiceFeeIncludedTitle from '../../ServiceFeeIncludedTitle'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
}

const getItemPhotoThumbnail = (
  photos:
    | Array<{
        isMain: boolean
        thumbnails: Array<{ type: string; url: string }>
      }>
    | undefined,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ isMain }) => isMain)

  return findThumbnail(photo, size)
}

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
  escrowNoteTranslationKey?: string
}

const DetailedPriceBreakdown = ({
  bundleSummary,
  isSellerBusiness,
  selectedItems,
  escrowNoteTranslationKey,
}: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const firstItem = selectedItems[0]
  const isBundle = selectedItems.length > 1

  if (!firstItem) {
    return (
      <ServiceFeeIncludedTitle
        itemId={selectedItemIds[0]!}
        isSellerBusiness={isSellerBusiness}
        shouldTrimTitle
        shouldMinimiseTitle
        itemPrice={price}
        totalItemPrice={priceWithBuyerProtectionFee}
        isDisabled
      />
    )
  }

  return (
    <ServiceFeeIncludedTitle
      itemId={selectedItemIds[0]!}
      isSellerBusiness={isSellerBusiness}
      shouldTrimTitle
      shouldMinimiseTitle
      itemPrice={price}
      serviceFee={buyerProtectionFee}
      totalItemPrice={priceWithBuyerProtectionFee}
      itemTitle={firstItem.title}
      itemsCount={selectedItems.length}
      itemPhotoSrc={getItemPhotoThumbnail(firstItem.photos)}
      escrowFees={
        isBundle
          ? // Passing data from bundle summary instead of fetching from escrow fees endpoint for now.
            // At the moment there is not support for multiple item id fetching for escrow fees
            formatEscrowFeeFallback(buyerProtectionFee)
          : undefined
      }
      escrowNoteTranslationKey={escrowNoteTranslationKey}
    />
  )
}

export default DetailedPriceBreakdown
